/* eslint-disable camelcase */
import { round_by_tick_size } from 'helpers/formulas';
import { addZeroesUntilCorrectPrecision, isNan } from 'helpers/utils';
import { spotPriceState, spotPriceSelectorBySymbol } from 'selectors/priceSelectors';
import { selectedProductIdSelector, getProductByID } from 'selectors/tradeSelectors';
import { useAppSelector } from 'storeHooks';

const useIndexPrice = ({ productId }) => {
  const selectedSpotPrice = spotPriceState() as string;
  const selectedProductId = useAppSelector(state => selectedProductIdSelector(state));

  const { tick_size: tickSize, spot_index: spotIndex } = useAppSelector(state =>
    getProductByID(state, {
      filterProductId: productId,
    })
  );
  const spotPrice =
    selectedProductId === productId.toString()
      ? selectedSpotPrice
      : spotPriceSelectorBySymbol(spotIndex?.symbol);
  const indexPrice = addZeroesUntilCorrectPrecision(
    round_by_tick_size(spotPrice as string, tickSize),
    tickSize
  );
  const displayValue = isNan(indexPrice) ? 0 : indexPrice;
  return displayValue;
};

export default useIndexPrice;
